import { Account } from '@/modules/Account/interfaces/account'
import { Contact } from '@/modules/Contact/interfaces/contact'
import { ReducedUser, User } from '@/modules/User/interfaces/user'
import { Producer } from '@/modules/Producer/interfaces/producer'
import { Carrier } from '@/modules/Carrier/interfaces/carrier'
import { CarrierProduct } from '@/modules/CarrierProduct/interfaces/carrier-product'
import { RecordType } from '@/modules/RecordType/interfaces/record-type'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { AcordForm } from '@/modules/AcordForm/interfaces/acord-form'
import { File } from '@/modules/File/interfaces/file'
import { Vehicle } from '@/modules/Vehicle/interfaces/vehicle'
import { Insured } from '@/modules/Insured/interfaces/insured'
import { Property } from '@/modules/Property/interfaces/property'
import { Label } from '@/modules/Label/interfaces/label'
import { QuoteCarrier } from '@/modules/Quote/interfaces/quote-carrier'
import { Case } from '@/modules/Case/interfaces/case'

export enum QuoteStatus {
  QUOTING = 'QUOTING',
  UNDERWRITING = 'UNDERWRITING',
  PROPOSE = 'PROPOSE',
  CLOSED = 'CLOSED',
}

export enum QuoteType {
  RENEWAL = 'RENEWAL',
  NEW_BUSINESS = 'NEW_BUSINESS',
  REWRITE = 'REWRITE',
  BOR = 'BOR',
  REMARKET = 'REMARKET'
}

export enum QuoteRequestCompanyType {
  CARRIER = 'CARRIER',
  GA = 'GA'
}

export interface queryFilter {
  name?: string | null
  caseId?: number | null,
  contactId?: number | null,
  accountId?: number | null,
  carrierProductId?: number | null,
  producerId?: number | null,
  isCaseRelated?: boolean | null
}

export interface Quote {
  id: number;
  name: string;
  status: QuoteStatus;
  type: QuoteType;
  originalInceptionDate: string;
  commissionPaymentEffectiveDate: string;
  commissionPaymentExpirationDate: string;
  currentCoverage: string;
  policyNumber: string;
  federalEmployerIdNumber: string;
  closed: boolean;
  createdAt: string;
  updatedAt: string;
  additionalInfoStr: string;
  caseId: number;
  caseInfo: Case;
  account: Account;
  primaryContact: Contact;
  source: Producer;
  carrier: Carrier;
  carrierProduct: CarrierProduct;
  priorTerm: Policy;
  recordType: RecordType;
  totalCommissionReceived: string;
  createdBy: ReducedUser;
  lastModifiedBy: ReducedUser;
  policies: Policy;
  acordForms: AcordForm[];
  attachments: File[];
  vehicles: Vehicle[];
  insureds: Insured[];
  properties: Property[];
  effectiveDate: string,
  expirationDate: string;
  labels: Label[];
  premiums: QuoteCarrier[];
  assignedUsers: User[];
}
